import { DocumentTokenInformation, Document } from "../../document";
import { WorkflowStatusName } from "../items";
import { WorkflowDocumentPermissions, WorkflowHisInformation } from ".";

// 依頼文書
export class WorkflowDocument {
  public targetId: number;
  public document: Document;
  public permissions: WorkflowDocumentPermissions;
  public status: WorkflowStatusName;
  public isDisableValidation: boolean;
  public nextMessageCommentId?: number; // 登録競合チェックで使用
  public nextMessageArchiveId?: number; // 登録競合チェックで使用
  public nextMessage: string;
  public backMessage: string;
  public workflowHisInformation: WorkflowHisInformation;
  public lastWorkflowHistoryId: string;
  public isAutoRegister: boolean;
  public createTokens: DocumentTokenInformation;
  public isWriteAndPublish: boolean;
  public isRegisteredWithPublish: boolean;
}
